import { bio, experiences, contact_links } from './data/PortfolioData'
import { FaLinkedinIn, FaGithub, FaInstagram } from 'react-icons/fa'
import { FaBluesky } from 'react-icons/fa6'
import { TbBrandLinktree } from 'react-icons/tb'
import { AwesomeButton } from 'react-awesome-button'
import 'react-awesome-button/dist/styles.css'

export default function PortfolioSections({ id }) {

    const contactLinks = [
        { iconButton: <FaLinkedinIn />, href: contact_links.linkedin },
        { iconButton: <FaGithub />, href: contact_links.github },
        { iconButton: <FaBluesky />, href: contact_links.bluesky },
        { iconButton: <TbBrandLinktree />, href: contact_links.linktree },
        { iconButton: <FaInstagram />, href: contact_links.instagram },
    ]

    return (
        <>
            <div className="over-canvas header-my-names">
                <span className='title-header my-name-normal' dangerouslySetInnerHTML={{ __html: bio.presentation.name_normal }}></span>
                <span className='title-header my-name-with-dog' dangerouslySetInnerHTML={{ __html: bio.presentation.name_with_dog }}></span>
            </div>

            <span id={id}>
                <section className="section section-bio">
                    <div className="description">
                        <h1 className='h1-bio-description'>{bio.presentation.firstPart_complete}</h1>
                        <div className='text-normal'>{bio.presentation.firstPart}<span className="role-animated-text">
                            {bio.roles.map((role, index) => {
                                return (
                                    <div className='role-line' key={index} dangerouslySetInnerHTML={{ __html: role.role }}></div>
                                )
                            })}
                            <div className='role-line' key={bio.roles.length} dangerouslySetInnerHTML={{ __html: bio.roles[0].role }}></div>
                        </span><span style={{ visibility: "hidden" }}>{bio.presentation.emptyPart}</span>{bio.presentation.secondPart}</div>
                        <div className='text-normal' dangerouslySetInnerHTML={{ __html: bio.description }}></div>
                    </div>
                </section>
                <section className="section section-experiences">
                    <div className="description">
                        <div className='title-header'>Games &<br />projects</div>
                    </div>
                </section>
                <section className="section section-contact">
                    <div className="description">
                        <div className='title-header'>Contact me</div>
                        <div className='text-normal contact-mail'>at <a href="mailto:hi@fernandog.cat">hi@fernandog.cat</a></div>
                        <div className='contact-links'>
                            {contactLinks.map((link, index) => {
                                return (
                                    <a target="_blank" className='contact-link' href={link.href} key={index}>
                                        <AwesomeButton
                                            type='custom'
                                            className='contact-link-container'
                                            onReleased={(event) => {
                                                window.open(link.href, '_blank')
                                            }}
                                        >
                                            {link.iconButton}
                                        </AwesomeButton>
                                    </a>
                                )
                            })}
                        </div>
                    </div>
                </section>
            </span>

            {/* <AwesomeButton
                type='custom'
                className='credits-button'
                onPress={(event, release) => {
                    const experienceInfoContainer = document.getElementsByClassName('experience-info-container')[0]
                    if (experienceInfoContainer.classList.contains("show")) {
                        experienceInfoContainer.classList.remove("show")
                        experienceInfoContainer.classList.add("hide")
                    } else {
                        experienceInfoContainer.classList.add("show")
                        experienceInfoContainer.classList.remove("hide")
                    }
                }}
            >
                Credits
            </AwesomeButton> */}
        </>
    )
}
